var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragableSixDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3C3.47386 3 3.25 2.77614 3.25 2.5C3.25 2.22386 3.47386 2 3.75 2C4.02614 2 4.25 2.22386 4.25 2.5C4.25 2.77614 4.02614 3 3.75 3Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.5C3.47386 6.5 3.25 6.27614 3.25 6C3.25 5.72386 3.47386 5.5 3.75 5.5C4.02614 5.5 4.25 5.72386 4.25 6C4.25 6.27614 4.02614 6.5 3.75 6.5Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10C3.47386 10 3.25 9.77614 3.25 9.5C3.25 9.22386 3.47386 9 3.75 9C4.02614 9 4.25 9.22386 4.25 9.5C4.25 9.77614 4.02614 10 3.75 10Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3C7.97386 3 7.75 2.77614 7.75 2.5C7.75 2.22386 7.97386 2 8.25 2C8.52614 2 8.75 2.22386 8.75 2.5C8.75 2.77614 8.52614 3 8.25 3Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6.5C7.97386 6.5 7.75 6.27614 7.75 6C7.75 5.72386 7.97386 5.5 8.25 5.5C8.52614 5.5 8.75 5.72386 8.75 6C8.75 6.27614 8.52614 6.5 8.25 6.5Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10C7.97386 10 7.75 9.77614 7.75 9.5C7.75 9.22386 7.97386 9 8.25 9C8.52614 9 8.75 9.22386 8.75 9.5C8.75 9.77614 8.52614 10 8.25 10Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragableSixDots);
export default __webpack_public_path__ + "static/media/dragable-six-dots.64ede3753d63b233299d9900644545cb.svg";
export { ForwardRef as ReactComponent };